<template>
  <div class="col-md-4 !tw-mx-auto login-wrapper blocked-account blocked-account review-account">
    <div class="login-logo">
      <img
        :src="logo"
        alt="logo"
      >
    </div>
    <form>
      <Card class="card-login">
        <img :src="hourglassImg">
        <h3>
          {{ $t('forms.unverifiedAccount.verifyEmail') }}
          <br>
        </h3>
        <div class="row">
          <div class="col-12 blocked-account__text">
            {{ $t('forms.unverifiedAccount.sentVerificationLink') }}
          </div>
        </div>
        <button
          class="btn btn-primary btn-md"
          @click="$router.push('/logout')"
        >
          &lt; {{ $t('forms.btn.logout') }}
        </button>
      </Card>
    </form>
  </div>
</template>

<script>
import hourglassImg from '@/assets/theme/icon/hourglass.svg';

export default {
  computed: {
    hourglassImg: () => hourglassImg,
    logo() {
      return this.$config.layout.logoFull;
    },
  },
};
</script>
